import React from "react";
import { Mail, Phone, MapPin, Clock, ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useReveal } from "../hooks/useReveal";
import { ItalyFlag } from "./ItalyFlag";

const EMAIL = "info@punteriabartesaghi.it";
const PHONE_DISPLAY = "+39 0341 580184";
const PHONE_TEL = "+390341580184";

export const Contatti = () => {
  const { t } = useI18n();
  const { ref, visible } = useReveal();

  return (
    <section
      id="contatti"
      ref={ref}
      data-testid="contact-section"
      className={`reveal ${visible ? "visible" : ""} relative bg-[#1a3a2a] text-white py-24 md:py-32 overflow-hidden grain`}
    >
      <div className="pb-container relative z-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="block w-12 h-px bg-[#c9a84c]" />
            <span className="text-overline">{t.contact.overline}</span>
          </div>
          <h2 className="font-heading font-bold tracking-tight text-3xl md:text-5xl leading-[1.1] uppercase text-white">
            {t.contact.title}
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-px bg-white/10">
          {/* Email card */}
          <a
            href={`mailto:${EMAIL}`}
            data-testid="contact-email-card"
            className="group bg-[#1a3a2a] hover:bg-[#11261b] p-10 md:p-14 flex flex-col transition-colors"
          >
            <Mail className="w-8 h-8 text-[#c9a84c] mb-8" strokeWidth={1.25} />
            <span className="text-overline">{t.contact.email}</span>
            <span className="mt-4 font-heading font-bold text-2xl md:text-4xl text-white tracking-tight break-all group-hover:text-[#c9a84c] transition-colors">
              {EMAIL}
            </span>
            <span className="mt-6 inline-flex items-center gap-2 text-sm text-white/60 group-hover:text-white transition-colors uppercase tracking-widest">
              {t.contact.writeUs}
              <ArrowUpRight
                className="w-4 h-4 group-hover:rotate-12 transition-transform"
                strokeWidth={1.5}
              />
            </span>
          </a>

          {/* Phone card */}
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="contact-phone-card"
            className="group bg-[#1a3a2a] hover:bg-[#11261b] p-10 md:p-14 flex flex-col transition-colors"
          >
            <Phone className="w-8 h-8 text-[#c9a84c] mb-8" strokeWidth={1.25} />
            <span className="text-overline">{t.contact.phone}</span>
            <span className="mt-4 font-heading font-bold text-2xl md:text-4xl text-white tracking-tight group-hover:text-[#c9a84c] transition-colors">
              {PHONE_DISPLAY}
            </span>
            <span className="mt-6 inline-flex items-center gap-2 text-sm text-white/60 group-hover:text-white transition-colors uppercase tracking-widest">
              {t.contact.callUs}
              <ArrowUpRight
                className="w-4 h-4 group-hover:rotate-12 transition-transform"
                strokeWidth={1.5}
              />
            </span>
          </a>

          {/* Address */}
          <div
            data-testid="contact-address-card"
            className="bg-[#1a3a2a] p-10 md:p-14 flex flex-col"
          >
            <MapPin className="w-8 h-8 text-[#c9a84c] mb-8" strokeWidth={1.25} />
            <span className="text-overline">{t.contact.address}</span>
            <span className="mt-4 inline-flex items-center gap-3 font-heading font-bold text-xl md:text-2xl text-white tracking-tight">
              Punteria Bartesaghi S.n.c.
              <ItalyFlag
                width={32}
                className="shadow-[0_1px_2px_rgba(0,0,0,0.4)]"
                title="Made in Italy"
              />
            </span>
            <span className="mt-1 text-white/70">{t.contact.addressValue}</span>
          </div>

          {/* Hours */}
          <div
            data-testid="contact-hours-card"
            className="bg-[#1a3a2a] p-10 md:p-14 flex flex-col"
          >
            <Clock className="w-8 h-8 text-[#c9a84c] mb-8" strokeWidth={1.25} />
            <span className="text-overline">{t.contact.hours}</span>
            <span className="mt-4 font-heading font-bold text-xl md:text-2xl text-white tracking-tight">
              {t.contact.hoursValue}
            </span>
          </div>
        </div>
      </div>

      {/* Decorative gold line */}
      <div className="absolute top-0 right-0 w-1/3 h-px bg-gradient-to-l from-[#c9a84c] to-transparent" />
    </section>
  );
};
